module.exports = __webpack_public_path__ + "static/Banner-16-77b6db2d473cb8fca8312cf77b400ba8.png";